import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import * as actions from '../../core/actions/contact.actions';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-contact-panel',
  templateUrl: './contact-panel.component.html',
  styleUrls: ['./contact-panel.component.scss']
})
export class ContactPanelComponent implements OnInit, OnChanges {

  public edit: boolean = false;
  @Input() contact: any;

  constructor(private store: Store<any>) { }

  ngOnInit() {
    if (this.contact && this.contact.id < 0 ) {
      this.edit = true;
    }
  }


  ngOnChanges(changes: SimpleChanges) {    
  	this.edit = this.edit && !(changes && changes.contact && changes.contact.currentValue && changes.contact.currentValue.saved);
  }  

  editContact() {
     this.edit = true;
  }

  cancel() {
  	this.edit = false;
  }

  save(contact: any) {
  	this.store.dispatch(new actions.SaveContactAction(contact));
  }

}
